import * as React from "react";
import type { SVGProps } from "react";
const SvgBowAndArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.21 9.32a2.58 2.58 0 0 1-1.83-.74 2.4 2.4 0 0 1-.277-.333l-1.009 1.009c1.842.928 3.461 2.658 3.596 7.004.07 2.27.54 2.75.6 2.79a1 1 0 0 1 1.38.26 1 1 0 0 1-.2 1.36 2.17 2.17 0 0 1-1.18.38 2 2 0 0 1-.83-.19c-.748-.36-1.241-1.155-1.506-2.425l-7.648-3.391-.156.156v2.95a1 1 0 0 1-.3.71l-2.87 2.78a1 1 0 0 1-.67.33 1 1 0 0 1-1-1v-2.3H2.98a1 1 0 0 1-.9-.7 1 1 0 0 1 .22-1l2.83-2.83a1 1 0 0 1 .71-.29h2.84l.22-.22-3.374-7.577C4.238 5.79 3.447 5.294 3.07 4.54a2.06 2.06 0 0 1 .24-2.13 1 1 0 0 1 1.4-.2 1 1 0 0 1 .21 1.38.16.16 0 0 0 0 .09s.43.48 2.79.55c4.335.134 6.07 1.74 7.002 3.572l.962-.964a2.5 2.5 0 0 1-.344-.278 2.54 2.54 0 0 1-.76-1.83 2.7 2.7 0 0 1 .81-1.92 2.74 2.74 0 0 1 1.85-.79l3.75-.05a1 1 0 0 1 .71.3 1 1 0 0 1 .29.7v3.37a2.67 2.67 0 0 1-.8 2.15 2.72 2.72 0 0 1-1.97.83m-7.405 4.225 2.777-2.777c1.459.543 2.982 1.524 3.142 5.388zM7.799 6.277c3.823.161 4.829 1.654 5.377 3.065l-2.781 2.788zM17.78 5.15a1 1 0 0 1 .94 1.33.74.74 0 0 0 .06.68.7.7 0 0 0 1-.05.68.68 0 0 0 .2-.57V3.97h-2.69a.72.72 0 0 0-.51.22.67.67 0 0 0-.21.49.6.6 0 0 0 .16.41.76.76 0 0 0 .72.06q.165-.021.33 0M6.31 16.67h-.89l.83-.87h1.9v1.92l-.84.84v-.89a1 1 0 0 0-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBowAndArrow;
